/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface VitalsRequest {
  /**
   * Height in inches
   * @exclusiveMinimum 0
   */
  height_in: number;
  /**
   * Weight in pounds
   * @exclusiveMinimum 0
   */
  weight_lb: number;
}
